import { combineReducers } from 'redux'

import app from './app'
import auth from './auth'
import branch from './branch'
import market from './market'
import socket from './socket'
import wallet from './wallet'
//import {reducer as notificationsReducer} from 'reapop';

// 모든 리듀서 합쳐서 내보내기
export default combineReducers({
    app,
    auth,
    branch,
    market,
    socket,
    wallet,
    //notifications: notificationsReducer()
})